import React from 'react';
import styled from 'styled-components';
import IRccDetails from '@sunbit-dev/common/models/IRccDetails';
import Input2, { InputType, InputBackground } from '../input/Input2';
import InputGroup from '../inputGroup/InputGroup';

// ############################ Styles ###########################
// tslint:disable:variable-name

const SRccSection = styled.section``;

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IRccFormProps {
  onChange: (value: string, name: string) => void;
  routingNumber?: string;
  accountNumber?: string;
  error: {
    routingNumber?: string;
    accountNumber?: string;
  };
}

// tslint:disable-next-line:variable-name
const RccForm: React.FC<IRccFormProps> = (props) => {
  const { routingNumber = '', accountNumber = '' } = props;
  const [values, setValues] = React.useState<IRccDetails>({ routingNumber, accountNumber });

  const handleOnChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { name } = event.target;
      const { value } = event.target;
      setValues({ ...values, [name]: value });
      props.onChange(value, name);
    },
    [...Object.values(values)]
  );

  return (
    <SRccSection>
      <InputGroup dataAt="rccInputs">
        <Input2
          color={'primary'}
          dataAt="routingNumber"
          name="routingNumber"
          className="inputInGroup"
          background={InputBackground.White}
          label="Routing number"
          placeholder="e.g 12345679"
          onChange={handleOnChange}
          value={values.routingNumber}
          type={InputType.Number}
          pattern="^\d{0,9}$"
          error={props.error.routingNumber}
          errorLabelAbsolutePosition={false}
        />
        <Input2
          color={'primary'}
          dataAt="accountNumber"
          name="accountNumber"
          className="inputInGroup"
          background={InputBackground.White}
          label="Account number"
          placeholder="e.g. 1234-5678-9090"
          onChange={handleOnChange}
          value={values.accountNumber}
          type={InputType.Number}
          pattern="^\d{0,17}$"
        />
      </InputGroup>
    </SRccSection>
  );
};

export default RccForm;
